import React from "react";

/**
 * Barra de tabs DS — bordes inferiores con indicador verde.
 * tabs: array de { id, label, count?, icon? }
 * value: id activo
 * onChange: (id) => void
 */
export function Tabs({ tabs, value, onChange, style }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 4,
        borderBottom: "1px solid var(--kr-border-subtle)",
        ...(style || {}),
      }}
    >
      {tabs.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              padding: "10px 12px",
              fontSize: 13,
              fontWeight: 600,
              color: active ? "var(--kr-fg-strong)" : "var(--kr-fg-muted)",
              borderBottom: active
                ? "2px solid var(--kr-action)"
                : "2px solid transparent",
              marginBottom: -1,
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              transition: "color var(--kr-dur-fast) var(--kr-ease-out)",
            }}
          >
            {t.label}
            {t.count != null && (
              <span
                style={{
                  background: active
                    ? "var(--kr-action-soft-bg)"
                    : "var(--kr-neutral-100)",
                  color: active
                    ? "var(--kr-action-soft-fg)"
                    : "var(--kr-fg-muted)",
                  fontSize: 10,
                  padding: "1px 6px",
                  borderRadius: 999,
                  fontWeight: 600,
                  minWidth: 18,
                  textAlign: "center",
                }}
              >
                {t.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
